import { render, staticRenderFns } from "./surgery_volume.vue?vue&type=template&id=bf974050&scoped=true"
import script from "./surgery_volume.vue?vue&type=script&lang=js"
export * from "./surgery_volume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf974050",
  null
  
)

export default component.exports